export default __webpack_public_path__ + "static/media/war2-copy.92cd9669.gif";